import { render, staticRenderFns } from "./WorkspaceCard.vue?vue&type=template&id=dcd98360"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports